import { capitalize } from "../../utils.js";
export function getSocialProviderDisplayName(authType) {
    return authType.displayName ?? capitalize(authType.authProviderId);
}
//# sourceMappingURL=types.js.map